import React from "react";
import Carousel from "../components/Carousel";
import "./Home.css";

const Home = () => {
  return (
    <div className="home-container">
      <Carousel />
    </div>
  );
};

export default Home;